import { useEffect, useState } from "react";

import { useGetLoggedIn }   from "_common/hooks/auth";
import { useSetLoginPopup } from "_common/hooks/global";
import { postLikeOnFeed }   from "_services/api/feed";

import Presentation from "./presentation";

const playerContainer = props => {

	const {
		thumbnail,
		changeVideoSrc,
		videoType,
		videoSrc,
		videoItem,
		toggleCollapse,
		startTime,
		nextVideoItem,
		previousRoute,
		from,
		userId,
		onClickCommentIcon,
		adTagURL
	} = props;

	const [ isVideoLike, setIsVideoLike ]   = useState ( false );
	const [ isVideoEnded, setIsVideoEnded ] = useState ( false );
	const [ timeLeft, setTimeLeft ]         = useState ( null );
	const isLoggedIn                        = useGetLoggedIn ();
	const setLoginPopup                     = useSetLoginPopup ();

	const mediaHref = `/video/${ nextVideoItem?.id }`;

	useEffect ( () => {
		setIsVideoLike ( !!videoItem.sportsFanReaction );
		setIsVideoEnded ( false );
		setTimeLeft ( null );
	}, [ videoItem ] );

	useEffect ( () => {
		if ( timeLeft === 0 ) {
			changeVideoSrc ();
			setTimeLeft ( null );
		}

		// exit early when we reach 0
		if ( !timeLeft )
			return;

		// save intervalId to clear the interval when the
		// component re-renders
		const intervalId = setInterval ( () => {

			setTimeLeft ( timeLeft - 1 );
		}, 1000 );

		// clear interval on re-render to avoid memory leaks
		return () => clearInterval ( intervalId );
		// add timeLeft as a dependency to re-rerun the effect
		// when we update it
	}, [ timeLeft ] );

	const sendReactionsOnVideo = async id => {
		try {
			await postLikeOnFeed ( { feedId: id } );
			setIsVideoLike ( true );

		} catch ( err ) {
			setIsVideoLike ( false );

			return;
		}
	};

	const onClickLike = () => {
		if ( !isLoggedIn ) {
			return setLoginPopup ( true );
		}
		if ( isVideoLike )
			return;

		sendReactionsOnVideo ( videoItem.id );
	};

	const onVideoEnd = () => {
		setIsVideoEnded ( true );
		setTimeLeft ( 5 );
	};

	const cancelClickHandler = () => {
		setIsVideoEnded ( false );
		setTimeLeft ( null );
	};

	const playNowClickHandler = () => {
		cancelClickHandler ();
		if ( nextVideoItem?.id )
			changeVideoSrc ();
	};

	return (
		<Presentation
			adTagURL = { adTagURL }
			cancelClickHandler = { cancelClickHandler }
			changeVideoSrc = { changeVideoSrc }
			feedId = { videoItem?.id }
			from = { from }
			isVideoEnded = { isVideoEnded }
			isVideoLike = { isVideoLike }
			mediaHref = { mediaHref }
			nextVideoItem = { nextVideoItem }
			onClickCommentIcon = { onClickCommentIcon }
			onClickLike = { onClickLike }
			onVideoEnd = { onVideoEnd }
			playNowClickHandler = { playNowClickHandler }
			previousRoute = { previousRoute }
			startTime = { startTime }
			thumbnail = { thumbnail }
			timeLeft = { timeLeft }
			toggleCollapse = { toggleCollapse }
			userId = { userId }
			videoItem = { videoItem }
			videoSrc = { videoSrc }
			videoType = { videoType }
		/>
	);
};

export default playerContainer;
